import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import routes from '../../config/settings/routes'
import { Typography } from '@chilecompra/react-kit/components'
import { useHasReachedMaxDate } from '../../modules/hooks/maxDate'
import { AccessToNewQuote, NewQuoteBox, OberverBox } from './NewQuoteAccess.styles'

/*
 * The new quote access' container
 */
const NewQuoteAccess = () => {
  const navigate = useNavigate()
  const hasReachedMaxDate = useHasReachedMaxDate()

  const handleCreateQuote = () => navigate(routes.quoteStepOne)
  const { authInfo } = useSelector(state => state.authorizationProvider)

  return (
    <>
      {!authInfo.hasObserverRole && (
        <NewQuoteBox>
          <Typography fontWeight="bold" variant="h4">
            Nueva Compra Ágil
          </Typography>
          <Typography color="black3" variant="body2">
            Publica tu llamado a cotizar en dos simples pasos.
          </Typography>
          {!hasReachedMaxDate && <AccessToNewQuote onClick={handleCreateQuote}>Crear Compra Ágil</AccessToNewQuote>}
        </NewQuoteBox>
      )}
      {authInfo.hasObserverRole && (
        <OberverBox>
          <Typography fontWeight="bold" variant="h4">
            No posees permisos para crear o editar una cotización.
          </Typography>
          <Typography color="black3" variant="body2">
            Puedes consultar el detalle de las cotizaciones creadas sin opción de realizar cambios.
          </Typography>
        </OberverBox>
      )}
    </>
  )
}

export default NewQuoteAccess
